import React from 'react';

interface ChevronIconProps {
  className?: string;
}

function ChevronIcon({ className }: ChevronIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.333 4.667L7 9.333l4.667-4.666"
      ></path>
    </svg>
  );
}

export default ChevronIcon;
